import { getStore } from "../store/store";
import type { TeamsPoliciesScenario } from "../store/schema";

export function isTeamsFeatureEnabled(_scenario?: TeamsPoliciesScenario): boolean {
    const { policies } = getStore();
    
    return !!policies?.teamsFeatureEnabled;
}
